/**
 * Formats a phone number string into a readable display format
 * @param phone Phone number string (ideally in E.164 format like +1XXXXXXXXXX)
 * @returns Formatted phone number string for display
 */
const formatPhoneNumber = (phone: string): string => {
  // Handle E.164 format (+1XXXXXXXXXX)
  if (phone.startsWith('+1')) {
    const digits = phone.substring(2); // Remove +1
    if (digits?.length === 10) {
      return `+1 (${digits.substring(0, 3)}) ${digits.substring(3, 6)}-${digits.substring(6)}`;
    }
  }
  return phone;
};

export { formatPhoneNumber };
